import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RouteObserverService {
  targetRoute: any[] = [];
  public routerObserver: Observable<any>;

  private configSubject: Subject<any>;

  constructor() {
    this.configSubject = new Subject<any>();
    this.routerObserver = this.configSubject.asObservable();
  }

  addRoute(route: any) {
    this.targetRoute.push(route);
    this.configSubject.next(route);
  }
}
